import { render, staticRenderFns } from "./ProjectName.vue?vue&type=template&id=72df06ea&scoped=true"
import script from "./ProjectName.vue?vue&type=script&lang=ts"
export * from "./ProjectName.vue?vue&type=script&lang=ts"
import style0 from "./ProjectName.vue?vue&type=style&index=0&id=72df06ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df06ea",
  null
  
)

export default component.exports